<template>
  <div
    :class="use"
    :style="{ '--bg-color': bgc || color[0], '--lg-color': lgc || color[1] }"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  name: "hBorder",
  props: {
    use: {
      type: String,
      default: "flow-1"
    },
    bgc: {
      type: String
    },
    lgc: {
      type: String
    },
    type: {
      type: String
    }
  },
  watch: {
    type: {
      handler(type) {
        if (type === "primary") this.color = ["#a0cfff", "#337ecc"]
        if (type === "success") this.color = ["#b3e19d", "#529b2e"]
        if (type === "warning") this.color = ["#f3d19e", "#b88230"]
        if (type === "danger") this.color = ["#fab6b6", "#c45656"]
        if (type === "info") this.color = ["#fab6b6", "#c45656"]
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      color: ["#a0cfff", "#337ecc"]
    }
  },
}
</script>

<style scoped lang="scss">
@keyframes rotate {
  100% {
    transform: rotate(1turn);
  }
}

// 渐变点线
.flow-1 {
  z-index: 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    z-index: -2;
    left: -50%;
    top: -50%;
    width: 200%;
    height: 200%;
    background-color: var(--bg-color);
    background-repeat: no-repeat;
    background-size: 50% 50%, 50% 50%;
    background-position: 0 0, 100% 0, 100% 100%, 0 100%;
    background-image: linear-gradient(transparent, transparent),
    linear-gradient(transparent, transparent),
    linear-gradient(transparent, transparent),
    linear-gradient(
        var(--bg-color),
        var(--bg-color),
        var(--lg-color),
        var(--bg-color),
        var(--bg-color),
        var(--bg-color),
        var(--bg-color)
    );
    animation: rotate 3s linear infinite;
  }

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 3px;
    top: 3px;
    bottom: 3px;
    right: 3px;
    background: white;
    border-radius: 5px;
  }
}

// 双渐变点线
.flow-2 {
  z-index: 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    z-index: -2;
    left: -50%;
    top: -50%;
    width: 200%;
    height: 200%;
    background-color: var(--bg-color);
    background-repeat: no-repeat;
    background-size: 50% 50%, 50% 50%;
    background-position: 0 0, 100% 0, 100% 100%, 0 100%;
    background-image: linear-gradient(transparent, transparent),
    linear-gradient(
        var(--bg-color),
        var(--bg-color),
        var(--bg-color),
        var(--bg-color),
        var(--lg-color),
        var(--bg-color),
        var(--bg-color)
    ),
    linear-gradient(transparent, transparent),
    linear-gradient(
        var(--bg-color),
        var(--bg-color),
        var(--lg-color),
        var(--bg-color),
        var(--bg-color),
        var(--bg-color),
        var(--bg-color)
    );
    animation: rotate 3s linear infinite;
  }

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 3px;
    top: 3px;
    bottom: 3px;
    right: 3px;
    background: white;
    border-radius: 5px;
  }
}

// 点线
.flow-3 {
  z-index: 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    z-index: -2;
    left: -50%;
    top: -50%;
    width: 200%;
    height: 200%;
    background-color: var(--bg-color);
    background-repeat: no-repeat;
    background-size: 50% 50%, 50% 50%;
    background-position: 0 0, 100% 0, 100% 100%, 0 100%;
    background-image: linear-gradient(transparent, transparent),
    linear-gradient(transparent, transparent),
    linear-gradient(transparent, transparent),
    linear-gradient(
        var(--lg-color),
        var(--bg-color),
        var(--bg-color),
        var(--bg-color),
        var(--bg-color)
    );
    animation: rotate 3s linear infinite;
  }

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 3px;
    top: 3px;
    bottom: 3px;
    right: 3px;
    background: white;
    border-radius: 5px;
  }
}

// 双点线
.flow-4 {
  z-index: 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    z-index: -2;
    left: -50%;
    top: -50%;
    width: 200%;
    height: 200%;
    background-color: var(--bg-color);
    background-repeat: no-repeat;
    background-size: 50% 50%, 50% 50%;
    background-position: 0 0, 100% 0, 100% 100%, 0 100%;
    background-image: linear-gradient(transparent, transparent),
    linear-gradient(
        var(--bg-color),
        var(--bg-color),
        var(--bg-color),
        var(--bg-color),
        var(--lg-color)
    ),
    linear-gradient(transparent, transparent),
    linear-gradient(
        var(--lg-color),
        var(--bg-color),
        var(--bg-color),
        var(--bg-color),
        var(--bg-color)
    );
    animation: rotate 3s linear infinite;
  }

  &::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 3px;
    top: 3px;
    bottom: 3px;
    right: 3px;
    background: white;
    border-radius: 5px;
  }
}
</style>
